import { Injectable } from '@angular/core';

@Injectable()
export class SnapShotService{
	public projects: Object = {};
	constructor(){}
}
